import './HowItWorks.css';

const STEPS = [
  { num:'01', title:'Post Your Role', desc:'Create a job posting with AI-assisted JD, add screening questions, attach an assessment, and publish — all in under 10 minutes.', icon:'💼', tag:'~10 mins' },
  { num:'02', title:'AI Screens Applicants', desc:'Every resume is parsed, skills extracted, and scored against your JD. You see a ranked leaderboard, not a pile of PDFs.', icon:'🤖', tag:'Instant' },
  { num:'03', title:'Candidates Take Assessments', desc:'Auto-invite shortlisted candidates to adaptive skill tests. Aptitude, coding, domain MCQs — auto-graded with anti-cheat.', icon:'📋', tag:'24–48 hrs' },
  { num:'04', title:'Schedule Interviews', desc:'One-click interview scheduling from the admin panel. Calendar sync, reminders, and structured feedback forms for every interviewer.', icon:'📅', tag:'1 click' },
  { num:'05', title:'Review Analytics & Decide', desc:'Recruiter dashboards, job funnels, pass vs fail charts, and assessment score distributions give you full data to make the right call.', icon:'📊', tag:'Real-time' },
  { num:'06', title:'Deliver Your Verdict', desc:'Offer management, acceptance tracking, and candidate notification — all within VERDICT. End the loop with a clear, documented decision.', icon:'✅', tag:'1-click offer' },
];

export default function HowItWorks() {
  return (
    <section id="how" className="section-divider">
      <div className="section-wrap">
        <span className="eyebrow">The VERDICT Process</span>
        <h2 className="sec-title">From job post to hire in days, not weeks.</h2>
        <p className="sec-sub" style={{marginBottom:'3.5rem'}}>
          A fully automated pipeline where AI handles the volume work — so your team
          focuses only on the people worth their time.
        </p>
        <div className="how-grid">
          {STEPS.map((s,i) => (
            <div key={s.num} className="how-step">
              <div className="how-step__connector" />
              <div className="how-step__num-wrap">
                <div className="how-step__num">{s.num}</div>
                <div className="how-step__icon">{s.icon}</div>
              </div>
              <div className="how-step__body">
                <div className="how-step__header">
                  <h4 className="how-step__title">{s.title}</h4>
                  <span className="how-step__tag">{s.tag}</span>
                </div>
                <p className="how-step__desc">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA in middle */}
        <div className="how-cta">
          <div className="how-cta__text">
            <h3>Ready to deliver your best hiring VERDICT?</h3>
            <p>Free trial. No credit card. Full platform access from day one.</p>
          </div>
          <button className="btn-purple" onClick={() => document.querySelector('#contact')?.scrollIntoView({behavior:'smooth'})}>
            Start Free Trial →
          </button>
        </div>
      </div>
    </section>
  );
}
